/** @jsx h */
import { h } from 'preact'
import Progress from './Progress'

const StageHeader = props => {
  const { count, total } = props

  return (
    <div class='StageHeader'>
      <div class='StageHeader-backdrop' />
      <Progress count={count} total={total} />
    </div>
  )
}

export default StageHeader
